import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ChartJs, { ChartConfiguration } from "chart.js/auto";
import { CanvasHTMLAttributes, ref, onMounted, inject, watch } from "vue";

export interface ChartElement extends HTMLCanvasElement {
  instance: ChartJs;
}

export type ProvideChart = (el: ChartElement) => void;

interface ChartProps extends CanvasHTMLAttributes, ChartConfiguration {
  width?: number;
  height?: number;
  type: ChartConfiguration["type"];
  data: ChartConfiguration["data"];
  options: ChartConfiguration["options"];
  refKey?: string;
}


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Chart',
  props: {
    width: null,
    height: null,
    type: null,
    data: null,
    options: null,
    refKey: null
  },
  setup(__props: any) {

const props = __props as {
  width?: number;
  height?: number;
  type: ChartConfiguration["type"];
  data: ChartConfiguration["data"];
  options: ChartConfiguration["options"];
  refKey?: string;
}



const chartRef = ref<ChartElement>();

const init = (el: ChartElement, props: ChartProps) => {
  const canvas = el?.getContext("2d");
  if (canvas) {
    const chart = new ChartJs(canvas, {
      type: props.type,
      data: props.data,
      options: props.options,
    });

    // Attach ChartJs instance
    el.instance = chart;
  }
};

const bindInstance = (el: ChartElement) => {
  if (props.refKey) {
    const bind = inject<ProvideChart>(`bind[${props.refKey}]`);
    if (bind) {
      bind(el);
    }
  }
};

onMounted(() => {
  if (chartRef.value) {
    bindInstance(chartRef.value);
    init(chartRef.value, props);
  }

  watch(props, () => {
    if (chartRef.value) {
      chartRef.value.instance.data = props.data;
      if (props.options) {
        chartRef.value.instance.options = props.options;
      }
      chartRef.value.instance.update();
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({
      width: `${__props.width}px`,
      height: `${__props.height}px`,
    })
  }, [
    _createElementVNode("canvas", {
      ref_key: "chartRef",
      ref: chartRef,
      class: _normalizeClass(_ctx.$attrs.class)
    }, null, 2)
  ], 4))
}
}

})